(function(){
  function scrollToConfigurator() {
    var t = document.getElementById('bundle-configurator');
    if (t) { try { t.scrollIntoView({behavior:'smooth', block:'start'}); } catch(e){ location.hash = '#bundle-configurator'; } }
    else { location.href = location.pathname + '#bundle-configurator'; }
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-scroll-config]');
    if (!btn) return;
    e.preventDefault();
    scrollToConfigurator();
  });
})();